import { render, staticRenderFns } from "./preview-image.vue?vue&type=template&id=2d82f4b3"
import script from "./preview-image.vue?vue&type=script&lang=js"
export * from "./preview-image.vue?vue&type=script&lang=js"
import style0 from "./preview-image.vue?vue&type=style&index=0&id=2d82f4b3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports